import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postMcpOAuthDeny } from '@api';

export const securityMcpOAuthDenyPostAsyncSlice = createPostAsyncSlice({
	name: 'SecurityMcpOAuthDeny',
	receive: true,
	request: true,
	requestHandler: postMcpOAuthDeny
});
